import React from 'react';
import {
  Col, Image, Row, Stack,
} from 'react-bootstrap';
import i18next from 'i18next';
import { SummingUp, PrevNextButton, BedingungsvergleichButton } from 'ion-lib';
import { getBannerFileName } from '../../helper';

const Prepage = () => (
  <Row>
    <Col>
      <div className="w-md p-0 spkpanel prepage">
        <Image src={getBannerFileName()} className="rounded-top mb-2 img-fluid" />
        <div className="spkpanel__info mb-4 px-3">
          <h2 className="h4 headline">{i18next.t('prepage.headline')}</h2>
          <hr />
          <ul className="list-icn-checkbullet list-item-ps-2 pb-2">
            {i18next.t('prepage.leistungen', { returnObjects: true })
              .map((leistungen) => (
                <li key={leistungen}>{leistungen}</li>
              ))}
          </ul>
        </div>
      </div>
    </Col>
    <SummingUp
      nobanner
      buttons={(
        <Stack gap={3}>
          <PrevNextButton
            nextProps={{
              size: 'lg',
              block: true,
              text: 'Jetzt starten',
            }}
          />
          <BedingungsvergleichButton />
        </Stack>
        )}
    >
      <ul className="summingup-list">
        <li className="checked">
          Ihr Zuhause
          <span>Details zu Ihrer Wohnung</span>
        </li>
        <li>
          Produktauswahl
          <span>Ihr persönlicher Versicherungsschutz</span>
        </li>
        <li>
          Kundendaten
          <span>Ihre persönlichen Angaben</span>
        </li>
        <li>
          Antrag
          <span>Ihr individueller Antrag</span>
        </li>
        <li>
          Abschluss
          <span>Zusammenfassung Ihrer individuellen Absicherung</span>
        </li>
      </ul>
    </SummingUp>
  </Row>
);

export default Prepage;
